<template>
  <general-container></general-container>
</template>

<script>
import {mapMutations} from 'vuex';
import { permissions } from '../service/permissions'
import { baseData } from '../service/baseData'
export default {
  data(){
    return {

    }
  },
  methods:{
    ...mapMutations([
      'CLEAR_ALL_TABS',
      'OPEN_MENU'
    ]),
    getActive(val){
      let active = "";
      for(let i = 0 ; i < permissions.length ; i++){
        if(permissions[i]['title'] == val){
          active = permissions[i]['children'][0]['title'];
          break;
        }
      };
      return active;
    }
  },
  created(){
    if(this.$route.params.activeIndex){
      let _url = (this.$route.params.activeIndex).split("?");
      let key = "";
      this.OPEN_MENU(_url[0]);
      if(_url[1]){
        key = _url[1];
      }else{
        key = this.getActive(_url[0]);
      }
      this.addTab({title:baseData[key]['name'],icon:baseData[key]['icon'],componentName:key,params:{}});
    }
  },
  destroyed(){
    this.CLEAR_ALL_TABS();
  }
}
</script>

<style lang="scss" scoped>

</style>





// WEBPACK FOOTER //
// src/pages/main.vue